import {Component, ViewEncapsulation} from '@angular/core';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';
import {ConfigService, DcpBundleTemplate, TransactionListCta} from '@dcp/configurator';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Product} from '@spartacus/core';
import {Observable} from 'rxjs';

@Component({
  selector: 'dcp-cta-info-page-modal',
  templateUrl: './cta-info-page-modal.component.html',
  styleUrls: ['./cta-info-page-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CtaInfoPageModalComponent {

  public sortedSlmTransactionTypes$: Observable<TransactionListCta[]>;
  public bundleTemplate: DcpBundleTemplate;
  public product: Product;

  CONTACT_SUPPORT = TransactionTypeCode.CONTACT_SUPPORT;
  MANAGE_ORDERS = TransactionTypeCode.MANAGE_ORDERS;
  manageOrdersUrl: string = '/financelegal';

  constructor(
    private activeModal: NgbActiveModal,
    public configService: ConfigService,
  ) {
  }

  close() {
    this.activeModal.close();
  }
}
